export default "__VITE_ASSET__3476303e__"